define('shared/remote/efid/const',[],function(){
    return {
        OAUTH2_FOLDER : 'oauth2',
        OAUTH2_ACTION_CREATE : 'users',
        OAUTH2_ACTION_AUTH : 'auth',
        OAUTH2_ACTION_LOGIN : 'cors/v1/login/email',
        OAUTH2_CLIENT_ID : 'englishlive',
        OAUTH2_SCOPE : 'labs-profile',
        OAUTH2_SCHEME : 'https',
        DEFAULT_REDIRECT: '/1/oauth2/redirect',
        CUSTOM_REDIRECT: '/1/oauth2/redirect?retrieve-tokens',
        RETRIEVE_DESTINATION: '/1/oauth2/redirect?retrieve-destination',
        RESET_UI: '/en/ui/reset/index.html'
    };
});
